import React, { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OverdueSpotlight({ active, show }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (active === "c0") {
      axios.get(`${API}/spotlight`).then((r) => setData(r.data)).catch(() => {});
    }
  }, [active]);

  if (active !== "c0" || !data || data.count === 0) return null;

  return (
    <div className="spotlight" data-testid="overdue-spotlight">
      <div className="spot-head" data-testid="spotlight-head">
        NEEDS ACTION TODAY — {data.count} blown or same-day deadline{data.count === 1 ? "" : "s"}
      </div>
      {data.items.map((it, i) => (
        <button key={i} className="spot-item" onClick={() => show(it.target)} data-testid={`spotlight-item-${i}`}>
          <span className={`spot-tag ${it.kind}`}>{it.kind === "blown" ? "OVERDUE" : "DUE TODAY"}</span>
          <span className="spot-text">{it.text}</span>
          <span className="spot-go">→</span>
        </button>
      ))}
    </div>
  );
}
